/* 37 sk. — repertuaro naršyklė. Vienas JSON, filtravimas kliento pusėje. */
(function () {
  'use strict';
  var CACHE = null, LOADING = null;

  function load(url) {
    if (CACHE) return Promise.resolve(CACHE);
    if (LOADING) return LOADING;
    LOADING = fetch(url).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (!d || !Array.isArray(d.songs)) throw new Error('Netinkama struktūra');
      CACHE = d; return d;
    });
    return LOADING;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function decade(y) { return Math.floor(y / 10) * 10; }

  function Explorer(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.songsReady === '1') return;
    root.dataset.songsReady = '1';

    var url = root.dataset.songsUrl;
    var handle = root.dataset.songsHandle || '';
    /* V117 §14 — MOBILE PRADEDA NUO 8 DAINŲ.

       v116 mobile screenshot: 16 dainų sąrašas nutęsdavo sekciją per
       kelis ekranus dar prieš kartų kontekstą. Desktop 16 lieka —
       ten keturios kolonos, todėl tai vos keturios eilutės.
       Matuojame VIENĄ kartą inicializacijos metu: `RODYTI DAUGIAU`
       toliau prideda tą patį batch'ą, todėl resize metu keisti žingsnį
       nereikia ir nauji listeneriai nekuriami. */
    var step = parseInt(root.dataset.songsStep, 10) || 12;
    var stepM = parseInt(root.dataset.songsStepMobile, 10) || 0;
    if (stepM > 0 && window.matchMedia('(max-width: 749px)').matches) step = stepM;
    var list = root.querySelector('[data-songs-list]');
    var decWrap = root.querySelector('[data-songs-decades]');
    var search = root.querySelector('[data-songs-search]');
    var more = root.querySelector('[data-songs-more]');
    var count = root.querySelector('[data-songs-count]');
    var empty = root.querySelector('[data-songs-empty]');
    var reset = root.querySelector('[data-songs-reset]');
    if (!url || !list) return;

    var all = [], view = [], shown = 0, era = null, q = '';

    function render(fresh) {
      if (fresh) { list.innerHTML = ''; shown = 0; }
      var slice = view.slice(shown, shown + step);
      var frag = document.createDocumentFragment();
      slice.forEach(function (s) {
        var li = document.createElement('li');
        li.className = 'song';
        /* §7.3: individualūs metai NERODOMI. Atlikėjas paryškintas, daina normali.
           Metai lieka duomenyse tik filtravimui. */
        /* V43 §11: atlikėjas ir daina — dvi atskiros eilutės, be brūkšnio.
           Vienoje eilutėje skirtingo ilgio tekstai stumdydavo visą grid. */
        li.innerHTML =
          '<strong class="song__a">' + esc(s.a) + '</strong>' +
          '<span class="song__t">' + esc(s.t) + '</span>';
        frag.appendChild(li);
      });
      list.appendChild(frag);
      shown += slice.length;
      if (more) more.hidden = shown >= view.length;
      if (count) {
        /* V41 §10.4: Y visada skaičiuojamas iš realaus datasource. */
        count.hidden = view.length === 0;
        var tpl;
        if (q.trim()) {
          tpl = (root.dataset.songsCountSearch || '')
            .replace('{n}', view.length).replace('{q}', q.trim());
        } else if (era) {
          tpl = (root.dataset.songsCountEra || '')
            .replace('{x}', shown).replace('{y}', view.length).replace('{era}', era.label);
        } else {
          tpl = (root.dataset.songsCountAll || '')
            .replace('{x}', shown).replace('{y}', view.length);
        }
        count.textContent = tpl;
      }
      if (empty) {
        empty.hidden = view.length !== 0;
        empty.textContent = root.dataset.songsNone || '';
      }
      if (reset) reset.hidden = !(q || era);
    }

    /* V41 §10.7 — aktyvus laikotarpis paryškina atitinkamą kartą.
       „Visi" paryškina kartą, pažymėtą data-gen-all. */
    function syncGens() {
      var wrap = root.parentNode ? root.parentNode.querySelector('[data-songs-gens]') : null;
      if (!wrap) return;
      wrap.querySelectorAll('.mgen').forEach(function (g) {
        var on;
        if (!era) {
          on = g.hasAttribute('data-gen-all');
        } else {
          var lo = parseInt(g.dataset.genLo, 10);
          var hi = parseInt(g.dataset.genHi, 10);
          on = !g.hasAttribute('data-gen-all') && era.lo >= lo && era.lo <= hi;
        }
        g.classList.toggle('is-active', !!on);
      });
    }

    /* ------------------------------------------------------------------
       V97 · H11 — SUBALANSUOTAS „VISI" RINKINYS

       PROBLEMA. `all` yra chronologinės tvarkos (prasideda 1908),
       todėl „Visi" būsenoje pirmos rodomos kortelės buvo seniausios
       dainos. Repertuare 1900–1960 m. yra vos 39 dainos iš 854, bet
       būtent jos ir pasitikdavo vartotoją.

       SPRENDIMAS. „Visi" būsenoje imamas subalansuotas pjūvis per
       dešimtmečius: kiekvienas laikotarpis paeiliui atiduoda po vieną
       dainą (round-robin), kol rinkinys išsemiamas. Taip pirmame
       ekrane matomi ir 2020-ųjų, ir 1990-ųjų, ir senesni įrašai.

       ATSITIKTINUMAS PER SESIJĄ, NE PER RENDER. Sėkla saugoma
       `sessionStorage`, todėl:
         - kiekvienas apsilankymas duoda kitą tvarką;
         - bet slenkant ir dokraunant tvarka NEŠOKINĖJA;
         - grįžus atgal sąrašas lieka toks pat.

       FEATURED SĄRAŠAS. Jei sekcijoje nurodytos populiarios dainos,
       balansas imamas TIK iš jų. Tuščias sąrašas -> balansas iš viso
       repertuaro. Filtrai pagal laikotarpį ir paieška NEKEIČIAMI.
       ------------------------------------------------------------------ */

    /* Determinuotas PRNG — ta pati sėkla duoda tą pačią tvarką. */
    function rng(seed) {
      var x = seed >>> 0;
      return function () {
        x ^= x << 13; x >>>= 0;
        x ^= x >> 17;
        x ^= x << 5; x >>>= 0;
        return x / 4294967296;
      };
    }

    function sessionSeed() {
      var k = 'mzSongsSeed', v = null;
      try { v = sessionStorage.getItem(k); } catch (err) {}
      if (!v) {
        v = String(Math.floor(Math.random() * 2147483647) + 1);
        try { sessionStorage.setItem(k, v); } catch (err) {}
      }
      return parseInt(v, 10) || 1;
    }

    var rand = rng(sessionSeed());

    function shuffled(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(rand() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    /* Featured sąrašas: po vieną „atlikėjas — pavadinimas" eilutėje. */
    var featuredKeys = (root.dataset.songsFeatured || '')
      .split('\n').map(function (l) { return l.trim().toLowerCase(); })
      .filter(Boolean);

    function key(s) { return (s.a + ' — ' + s.t).toLowerCase(); }

    function balanced(pool) {
      /* Grupuojame pagal dešimtmetį, kiekvieną maišome sesijos sėkla,
         tada imame paeiliui po vieną iš kiekvieno. */
      var buckets = {};
      pool.forEach(function (s) {
        var d = decade(s.y);
        (buckets[d] = buckets[d] || []).push(s);
      });
      var keys = Object.keys(buckets);
      keys.forEach(function (k) { buckets[k] = shuffled(buckets[k]); });

      /* PROPORCINGAS, ne lygus paskirstymas.

         Paprastas round-robin (po vieną iš kiekvieno dešimtmečio)
         duotų 1900–1960 m. dainoms 38 % pirmojo ekrano, nors jos
         sudaro vos 4,6 % repertuaro. Tai vėl būtų „per daug senų".

         Todėl kiekvienai dainai priskiriamas raktas
         (pozicija + 0,5) / dešimtmečio_dydis. Didesni dešimtmečiai
         savo dainas išdėsto tankiau, mažesni — rečiau, todėl mišinys
         atspindi realias proporcijas, bet nė vienas laikotarpis
         nedingsta. */
      var out = [];
      keys.forEach(function (k) {
        var b = buckets[k], n = b.length;
        b.forEach(function (song, i) {
          out.push({ s: song, w: (i + 0.5) / n });
        });
      });
      out.sort(function (a, b) { return a.w - b.w; });
      return out.map(function (x) { return x.s; });
    }

    function apply() {
      var needle = q.trim().toLowerCase();
      view = all.filter(function (s) {
        if (era && (s.y < era.lo || s.y > era.hi)) return false;
        if (!needle) return true;
        return s.a.toLowerCase().indexOf(needle) !== -1 ||
               s.t.toLowerCase().indexOf(needle) !== -1;
      });

      /* Balansuojame TIK „Visi" be paieškos. Pasirinkus laikotarpį ar
         ieškant vartotojas laukia natūralios tvarkos. */
      if (!era && !needle) {
        var pool = view;
        if (featuredKeys.length) {
          var feat = view.filter(function (s) {
            return featuredKeys.indexOf(key(s)) !== -1;
          });
          /* Jei featured sąrašas duoda per mažai, krentame į visą
             repertuarą — geriau pilnas balansas nei tuščias ekranas. */
          if (feat.length >= 12) pool = feat;
        }
        view = balanced(pool);
      }

      render(true);
    }

    load(url).then(function (data) {
      var scopeHandles = handle ? handle.split(',').map(function (h) { return h.trim(); }).filter(Boolean) : [];
      all = data.songs.filter(function (s) { return !scopeHandles.length || scopeHandles.indexOf(s.h) !== -1; });
      if (!all.length) { root.closest('section').hidden = true; return; }

      /* §7.2: laikotarpių tabai. Jei nurodyti data-songs-eras — naudojame juos,
         kitaip generuojame dešimtmečius iš realių duomenų. */
      var eras = (root.dataset.songsEras || '').split(',')
        .map(function (e) { return e.trim(); }).filter(Boolean)
        .map(function (e) {
          var p = e.split('-');
          return { lo: parseInt(p[0], 10), hi: parseInt(p[1], 10), label: p[0] + '–' + p[1] };
        })
        .filter(function (e) {
          return all.some(function (s) { return s.y >= e.lo && s.y <= e.hi; });
        });

      if (!eras.length) {
        var decs = [];
        all.forEach(function (s) {
          var d = decade(s.y);
          if (decs.indexOf(d) === -1) decs.push(d);
        });
        decs.sort(function (a, b) { return a - b; });
        eras = decs.map(function (d) { return { lo: d, hi: d + 9, label: String(d) }; });
      }

      if (decWrap) {
        var html = '<button type="button" class="songs__dec is-active" data-era="" aria-pressed="true" aria-current="true">'
          + esc(root.dataset.songsAll || 'Visi') + '</button>';
        eras.forEach(function (e, i) {
          html += '<button type="button" class="songs__dec" data-era="' + i
            + '" aria-pressed="false" aria-current="false">' + esc(e.label) + '</button>';
        });
        decWrap.innerHTML = html;
        decWrap.addEventListener('click', function (ev) {
          var b = ev.target.closest('[data-era]');
          if (!b) return;
          era = b.dataset.era === '' ? null : eras[parseInt(b.dataset.era, 10)];
          decWrap.querySelectorAll('[data-era]').forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
            x.setAttribute('aria-current', on ? 'true' : 'false');
          });
          syncGens();
          apply();
        });
      }
      syncGens();
      apply();
    }).catch(function (e) {
      if (empty) { empty.hidden = false; empty.textContent = root.dataset.songsNone || ''; }
      if (window.console) console.warn('Repertuaras:', e);
    });

    if (search) search.addEventListener('input', function () { q = search.value; apply(); });
    if (more) more.addEventListener('click', function () { render(false); });
    if (reset) reset.addEventListener('click', function () {
      q = ''; era = null;
      if (search) search.value = '';
      if (decWrap) decWrap.querySelectorAll('[data-era]').forEach(function (x, i) {
        x.classList.toggle('is-active', i === 0);
        x.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        x.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      });
      syncGens();
      apply();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-songs-root]').forEach(function (n) {
      if (n._mzSongs) return;
      n._mzSongs = true;
      Explorer(n);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();
